import { render } from "./App.vue?vue&type=template&id=33c6f402"
const script = {}

import "./App.vue?vue&type=style&index=0&id=33c6f402&lang=scss"
script.render = render

export default script